module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "headerStyle": {
        'background-color': _vm.currentIntegration.color.main
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Viator")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }), _vm._v(" "), (_vm.currentIntegration.integrationStatus != 1) ? _c('state-label', {
    attrs: {
      "integration": _vm.currentIntegration
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "px-5 pt-3 pb-4"
  }, [(_vm.currentIntegration.integrationStatus == 1) ? _c('div', {
    staticClass: "mb-4 pb-2"
  }, [_c('label', [_vm._v("Integration Key")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIntegration.apiKey),
      expression: "currentIntegration.apiKey"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.currentIntegration.apiKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIntegration, "apiKey", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('bottom-area', {
    attrs: {
      "isIntegrated": _vm.currentIntegration.integrationStatus == 1
    },
    on: {
      "disableIntegration": function($event) {
        return _vm.disableIntegration()
      },
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7f2bf0de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f2bf0de"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/viatorIntegrate.vue
// module id = 3213
// module chunks = 0